import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-stage water-glow-soft py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j9gwqm2xz77s">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1n9iqm92fqwci">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-162" data-mp="1ncwpv8fsypfq">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-silver/40 bg-navyPanel shadow-lift" data-id="element-163" data-mp="1x9rodrc2spu0">
          <div className="metal-bar h-2 w-full" aria-hidden="true" data-id="element-164" data-mp="226i6slbcrxil" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2v8kbkbvye9v">
            <span className="metal-surface inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-navyDeep" data-id="element-166" data-mp="2wa1m6jhvx01">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mgy8vapui2vu" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-silverEdge pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hpoksejy37m2">
              <div data-id="element-169" data-mp="1cr4vc4657doy">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-170" data-mp="1coim803lsq4m">{productName}</h3>
                <p className="mt-2 text-sm text-silver" data-id="element-171" data-mp="25fafoptab0o9">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="1vgtk1fjehxvv">
                <span className="text-sm text-silverDark" data-id="element-173" data-mp="1vfjlyqcjspp8">
                  Regular price <span className="line-through" data-id="element-174" data-mp="1req002io1kyz">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-white" data-id="element-175" data-mp="k39073w81tua">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-silver" data-id="element-176" data-mp="g0cm9qhmmlwo">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="hfx8bkapt7jl">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-silverBright" data-id="element-178" data-mp="mei85im21p7i">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver" aria-hidden="true" data-id="element-179" data-mp="ciomn9qcyldl" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3uul4is7pvrgj">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silver" data-id="element-181" data-mp="3kzt4ziukquj4">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3pxuog4vwwvv4">
                <LockIcon className="h-4 w-4 text-silverBright" aria-hidden="true" data-id="element-183" data-mp="3byv0kzg84l00" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3fyvrhjkieony">
                <ZapIcon className="h-4 w-4 text-silverBright" aria-hidden="true" data-id="element-185" data-mp="2xabhpnqcmnrn" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2sdbmy8yy97fu">
                <ShieldCheckIcon className="h-4 w-4 text-silverBright" aria-hidden="true" data-id="element-187" data-mp="36bjchvtnp6gz" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-silverDark" data-id="element-188" data-mp="31b576ljfwamn">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}